// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"732":"0361648c","977":"bd1e9ec9"}[chunkId] + ".chunk.js";
};